import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import ShopIcon from "@mui/icons-material/Shop";
import DownloadIcon from "@mui/icons-material/Download";
import { QRCodeSVG } from "qrcode.react";

// Tarjeta de descarga para un enlace de Google Play pegado en una noticia. En la versión completa incluye un QR
// para escanear con el celular desde la computadora; la compacta (tarjetas de listado) solo lleva el botón.
export default function PlayStoreCard({ url, paquete, compacta = false, sx }) {
  if (!url) return null;

  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        alignItems: "center",
        gap: 2,
        p: compacta ? 1.25 : 2,
        borderRadius: 2,
        border: 1,
        borderColor: alpha(theme.palette.success.main, 0.35),
        bgcolor: alpha(theme.palette.success.main, theme.palette.mode === "dark" ? 0.1 : 0.05),
        ...(typeof sx === "function" ? sx(theme) : sx),
      })}
    >
      <Box
        aria-hidden
        sx={{
          width: compacta ? 36 : 48,
          height: compacta ? 36 : 48,
          flexShrink: 0,
          borderRadius: 2,
          display: "grid",
          placeItems: "center",
          bgcolor: "success.main",
          color: "success.contrastText",
        }}
      >
        <ShopIcon sx={{ fontSize: compacta ? 20 : 26 }} />
      </Box>

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant={compacta ? "body2" : "subtitle2"} sx={{ fontWeight: 800, lineHeight: 1.3 }}>
          Disponible en Google Play
        </Typography>
        {!compacta && (
          <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 1 }} noWrap title={paquete}>
            Descarga la app en tu celular Android
          </Typography>
        )}
        <Button
          variant="contained"
          color="success"
          size="small"
          disableElevation
          startIcon={<DownloadIcon />}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ textTransform: "none", fontWeight: 700, mt: compacta ? 0.5 : 0 }}
        >
          Descargar app
        </Button>
      </Box>

      {!compacta && (
        <Stack alignItems="center" spacing={0.5} sx={{ display: { xs: "none", sm: "flex" }, flexShrink: 0 }}>
          {/* Fondo blanco fijo: un QR necesita contraste alto para que la cámara lo lea, también en tema oscuro. */}
          <Box sx={{ p: 0.75, bgcolor: "#fff", borderRadius: 1, lineHeight: 0 }}>
            <QRCodeSVG value={url} size={88} level="M" bgColor="#ffffff" fgColor="#000000" />
          </Box>
          <Typography variant="caption" color="text.secondary" sx={{ fontSize: 11 }}>
            Escanea con tu celular
          </Typography>
        </Stack>
      )}
    </Box>
  );
}
